import apiClient from './api';
import type { User, UserLogin, Token } from '../types';

export const adminService = {
  login: async (credentials: UserLogin): Promise<Token> => {
    const response = await apiClient.post('/api/admin/login', credentials);
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get('/api/admin/me');
    return response.data;
  },

  logout: (): void => {
    localStorage.removeItem('access_token');
  },
};
